// UI texts shared across screens.
export default {
  nav: { camp: 'Camp', map: 'Map', survivor: 'Survivor', inventory: 'Inventory', workshop: 'Workshop', skills: 'Skills', collection: 'Collection', feed: 'Feed' },
  brand: 'After Day',
  loading: 'Loading…',
  error: 'Could not load this. Check your connection.',
  retry: 'Try again',
  back: 'Back',
  close: 'Close',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  haveNeed: '{have} of {need}',
  hpFullIn: 'full in {t}',
  storageFull: "Storage full: loot that doesn't fit is left behind.",
  /** 23. 10. 2026 (owner, pilot report): once Tobias is at camp he buys what doesn't fit, for a little Scrap. */
  storageFullTobias: "Storage full: Tobias buys resources that don't fit, for a little Scrap. Make room to keep them.",
  featureOff: 'Not available yet',
  featureOffBody: 'This part of the game is switched off for now. It comes back in a later update.',
  new: 'NEW',
  /** iOS Safari in a tab: how to get push (it needs the home screen). */
  pwaHint: 'Get notified when your survivor is back: tap Share, then Add to Home Screen.',
  shareIcon: 'Share',
  /** Krug 5 (K16.2): a system not open yet, and the button on the toast when one opens. */
  unlocksAt: 'Opens at Lv {n}',
  /** 29. 9. 2026: a locked menu entry says it only in its tooltip. 10. 10. 2026 (owner): "Opens at level N". */
  unlocksAtLevel: 'Opens at level {n}',
  opensAfterRuns: 'Opens after your first two runs.',
  /** 10. 10. 2026 (owner): the popup of a system just opened (or of a thing needed now). */
  unlock: { new: 'New', try: 'Try it', later: 'Later' },
  /** 23. 10. 2026 (owner): the popup with the last update's changes. */
  whatsNew: { tag: 'Update', ok: 'Got it' },
  lockedAria: '{name}, locked',
  learnMore: 'Learn more',
  guide: 'Guide',
  unlockAction: 'Show me',
  energy: 'Energy',
  hp: 'HP',
  lv: 'LV {n}',
  /** 20. 10. 2026 (owner): a renamed survivor, with the name someone knew them by. */
  formerly: '{name} (was {former})',
  wasName: 'was {former}',
  /** Survivor Rank after level 20 (krug 5, F12). */
  lvRank: 'LV {n} · RANK {rank}',
  level: 'Level',
  power: 'Power',
  scrap: 'Scrap',
  /** Krug 5 (K9b): the currency in the top bar. */
  scrapInfo: "Scrap is your currency. Found on expeditions, earned from salvage, contracts and the Trader. Doesn't use Storage space.",
  scrapAria: 'Scrap: {n}. What is Scrap?',
  plusIn: '+1 in {t}',
  /** Krug 5 (K17.3): the header's energy tip. */
  energyTip: '{pace} · next in {next} · full in {full}',
  energyTipFull: '{pace} · full',
  /** 30. 9. 2026: faster below level 10. */
  energyPace: '+1 every {h}h',
  /** 7. 10. 2026 (owner): the maximum in the energy tip. */
  energyMaxTip: 'max {n}',
  full: 'Full',
  tracks: 'Tracks',
  more: 'More',
  season: 'Season',
  collection: 'Collection',
  appearance: 'Appearance',
  history: 'Past reports',
  unread: 'Unread notifications',
  feedback: {
    menu: 'Feedback',
    title: 'Send feedback',
    intro: 'A bug, something unclear, an idea? Tell us. We read every message.',
    label: 'Your message',
    placeholder: 'What happened, and what did you expect?',
    addShot: 'Add a screenshot',
    replaceShot: 'Another screenshot',
    removeShot: 'Remove',
    shotAlt: 'Screenshot to send',
    shotError: 'Could not use that picture. Try a PNG or JPEG.',
    page: 'Sent with the screen you are on: {page}',
    send: 'Send',
    thanks: 'Thanks',
    thanksBody: 'Your message is with the team.',
  },
  settings: 'Settings',
  friends: 'Friends',
  /** 20. 10. 2026 (owner): the Survivors list. */
  players: 'Survivors',
  clan: 'Crew',
  workshop: 'Workshop',
  skills: 'Skills',
  horde: 'Horde',
  /** 11. 10. 2026 (owner, docs/thepit.md). */
  pit: 'The Pit',
  notifications: 'Notifications',
  signOut: 'Sign out',
  devTools: 'Dev tools',
  /** Package 4, part C: injuries and fever. */
  /** Package 4, part M: the move to the new address. */
  move: {
    title: '{name} has a new home',
    body: 'The game moved to {domain}. Your survivor comes along: you stay signed in.',
    go: 'Go to the new home',
    pushTitle: 'Turn notifications back on',
    pushBody: 'The game moved to {domain}, and notifications from the old address stopped. Turn them on here.',
    homeScreen: 'On your phone, add {name} to your Home Screen again: the old icon opens the old address.',
    pushButton: 'Turn on notifications',
    pushOn: 'Notifications are on.',
    pushNo: 'Notifications are still off. Allow them in your browser settings.',
    later: 'Later',
  },
  conditions: {
    left: '{t} left',
    untilDressed: 'until a Bandage dresses it',
    useMedkit: 'Use a Medkit ({n})',
    useBandage: 'Dress it with a Bandage',
    scanned: 'WARDEN scans for injuries too: its drones find you more often.',
  },
  /** Package 4, part A: the guided steps (the sentences are in shared guided.ts). */
  guided: {
    waiting: 'Come back when {name} returns.',
    ok: 'OK',
    skip: 'Skip',
    skipAsk: "Skip this step? It won't come back. The Guide still explains it.",
    skipYes: 'Skip step',
    keep: 'Keep going',
    /** 9. 10. 2026: the step's element is under an open sheet (a ring round its Close). */
    closeFirst: 'Close this to go on.',
    /** 10. 10. 2026 (owner): the intro popup of the runs and the attributes. */
    gotIt: 'Got it',
    /** 10. 10. 2026 (owner): a stage of several taps (the second run's Bandages) ends with Done. */
    done: 'Done',
  },
  tutorial: {
    equipTitle: 'New gear from your first run',
    equipBody: 'Put it on: gear raises Power. Two or more pieces of one set switch on a set bonus.',
    equipCta: 'Open it',
  },
  rarity: { common: 'Common', uncommon: 'Uncommon', rare: 'Rare', epic: 'Epic', legendary: 'Legendary' },
  danger: { 1: 'Quiet', 2: 'Uneasy', 3: 'Hostile', 4: 'Lethal', 5: "Don't" },
  ago: { now: 'now', min: '{n} min ago', h: '{n} h ago', d: '{n} d ago' },
  /** Player search (names are not unique, so it lists everyone who fits). */
  search: { searching: 'Searching…', none: 'No survivor with that name or code.', meta: 'Lv {level} · {background}', you: 'You' },
  /** Krug 5 (K12.1): the item tier tag and its explanation (levels from TIER_LEVELS, F8.4). */
  tier: 'T{n}',
  tierLevel: 'T{n} Lv {lv}',
  // 23. 10. 2026 (BACKLOG #55): the tier's level is where an item has its full stats; one tier up is worn before it.
  tierExplain: "Tier sets the item's base strength and the level it has its full stats from. {levels}.",
  tierAhead: 'One tier above yours can be worn now, as the top of your tier with the same rolls, until its level.',
  tierAria: 'Tier {n}: what does it mean?',
} as const;
